import { StyleSheet, View } from 'react-native'

import { useFlowStepFrame } from '../hooks/useNestedSheetHeight'
import { useTheme } from '../theme/restyle'
import { KYC_FORM_METRICS } from './kycFormTheme'
import type { KycPosition } from './kycFormPosition'

export function FiatKycPosition({ position }: { position: KycPosition }) {
  // L1 and L2 currently share the design's fixed three-position indicator.
  const count = 3
  const theme = useTheme()
  const { paddingTop } = useFlowStepFrame()
  return (
    <View
      pointerEvents="none"
      style={[
        styles.progress,
        {
          top:
            paddingTop +
            KYC_FORM_METRICS.backButtonTop +
            (KYC_FORM_METRICS.backButtonSize - 10) / 2,
        },
      ]}
      accessibilityRole="progressbar"
      accessibilityValue={{ min: 1, max: count, now: position }}
    >
      {Array.from({ length: count }, (_, dot) => (
        <View
          key={dot}
          style={[
            styles.dot,
            {
              backgroundColor:
                dot + 1 === position
                  ? theme.content.elements.primary
                  : theme.content.elements.ghosted,
            },
          ]}
        />
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  progress: {
    position: 'absolute',
    alignSelf: 'center',
    flexDirection: 'row',
    gap: 5,
  },
  dot: { width: 10, height: 10, borderRadius: 5 },
})
